﻿export type User = {
	firstName?: string | null;
	lastName?: string | null;
	username?: string | null;
};

export type BuildUserDisplayNameOptions = {
	truncateLastName: boolean;
};

/**
 * Used to build user display name (eg. used for app header).
 *
 * @param user - user object containing first name, last name and username
 * @param options - if truncateLastName set to true, last name will be truncated to first letter in the format of "D."
 * @return string - If user object contains both first and last name, it will return a string in the format of "John Doe".
 * If user object doesn't contain first or last name, it will return username. If user object is null or undefined or empty, it will return empty string.
 */
export function buildUserDisplayName(user: User | null | undefined, options?: BuildUserDisplayNameOptions): string {
	if (!user) {
		return '';
	}

	const firstName = user.firstName ?? '';
	let lastName = user.lastName ?? '';
	if (!firstName && !lastName) {
		return user.username ?? '';
	}

	if (options?.truncateLastName && lastName) {
		lastName = `${lastName.charAt(0)}.`;
	}

	return `${firstName} ${lastName}`;
}
